<p500-ui-many-items [data]="data" [title]="title" [tmpl]="tmpl"></p500-ui-many-items>
<ng-template let-data="data" #tmpl>
  <gtd-ui-field-default-link [link]="[link, data?.id]" [displayData]="data?.name" [relationData]="data?.id" [rbacProperty]="rbac">
  </gtd-ui-field-default-link>
</ng-template>
